<template>

    <div class="bundle-pricing-table-1 bundle-pricing-table" :id="curTable.tableId"
        @mouseover="showBlockActionButtons = true" 
        @mouseleave="showBlockActionButtons = false" >

        <div v-if="showBlockChildSettingsGuide" class="settings-box-child-guide" :id="'child-block-settings-'+curTable.tableId+'-guide'"></div>

        <!-- slide settings -->
        <transition name="slide-fade">

            <vue-draggable-resizable 
            :resizable="false" 
            :drag-handle="'.settings-box-child-title'"
            :w="setBoxWidth" :h="setBoxHeight" :z="999" 
            class="settings-box-child" 
            v-if="showChildSettings" 
            :x="centerPositionSettingsBoxX"
            :y="centerPositionSettingsBoxY"

            :id="'child-block-settings-'+curTable.tableId">
                <!-- settings group: CHILD BLOCKS -->
                <div class="settings-box-child-title">
                    <h6>pricing table settings</h6>
                </div>

                <div class="settings-box-child-inner">

                    <!-- PLAN NAME -->
                    <div class="setting-section">
                        <div class="setting-section-title">
                            <h6>Plan name</h6>
                        </div> 
                        <div class="setting-section-content">
                            <!-- plan name -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="planname-text-input">Plan name:</label>

                                    <b-form-input id="planname-text-input" type="text" v-model="curTable.planName" size="sm" />

                                </b-form-group>
                            </div>
                            <!-- font family plan -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !curTable.useCustomFontPlan">
                                <b-form-group>
                                    <div style="display: flex">
                                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                                    </div>
                                    <b-form-select :options="googleFontsArray" @change="applyFont(arrayIndex,'fontGoogleLoadPlan','fontFamilyPlan','fontStylePlan','fontWeightPlan')" 
                                   size="sm" v-model="curTable.fontGoogleLoadPlan" />
                                </b-form-group>
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.useCustomFontPlan" name="use-custom-font">
                                    Use custom font
                                </b-form-checkbox>
                            </div>

                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && curTable.useCustomFontPlan" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                                <b-form-group>

                                    <div class="setting">
                                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-input id="button-customFontName" type="text" v-model="curTable.customFontNamePlan" size="sm" />
                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-select id="button-customFontWeight" v-model="curTable.customFontWeightPlan" size="sm">
                                            <option value="100">Thin - 100</option>
                                            <option value="200">Extra-LIght - 200</option>
                                            <option value="300">Light - 300</option>
                                            <option value="400">Regular - 400</option>
                                            <option value="500">Medium - 500</option>
                                            <option value="600">Semi-Bold - 600</option>
                                            <option value="700">Bold - 700</option>
                                            <option value="800">Extra-Bold - 800</option>
                                            <option value="900">Black - 900</option>
                                        </b-form-select>

                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                        <b-form-select id="button-customFontStyle" v-model="curTable.customFontStylePlan" size="sm">
                                            <option value="normal">Normal</option>
                                            <option value="italic">Italic</option>
                                        </b-form-select>
                                    </div>

                                </b-form-group>
                            </div>

                            <!-- font size plan -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="button-fontsizeTitle-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="curTable.fontSizePlan" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>


                            <!-- card title color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="colorPlan" theColorPicker="allpickers" colorPickerName="Plan title color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <!-- card title color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="bgPlan" theColorPicker="allpickers" colorPickerName="Plan title background:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>
                        </div><!-- setting-section-content -->
                    </div><!-- setting-section -->

                    <!-- PRICE -->
                    <div class="setting-section">
                        <div class="setting-section-title">
                            <h6>Price</h6>
                        </div> 
                        <div class="setting-section-content">
                            <!-- plan price -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="planprice-text-input">Price plan:</label>

                                    <b-form-input id="planprice-text-input" type="text" v-model="curTable.price" size="sm" />

                                </b-form-group>
                            </div>

                            <!-- font family price -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !curTable.useCustomFontPrice">
                                <b-form-group>
                                    <div style="display: flex">
                                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                                    </div>
                                    <b-form-select :options="googleFontsArray" @change="applyFont(arrayIndex,'fontGoogleLoadPrice','fontFamilyPrice','fontStylePrice','fontWeightPrice')" v-model="curTable.fontGoogleLoadPrice" size="sm" />
                                </b-form-group>
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.useCustomFontPrice" name="use-custom-font">
                                    Use custom font
                                </b-form-checkbox>
                            </div>

                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && curTable.useCustomFontPrice" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                                <b-form-group>

                                    <div class="setting">
                                        <label for="price-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-input id="button-customFontName" type="text" v-model="curTable.customFontNamePrice" size="sm" />
                                    </div>

                                    <div class="setting">
                                        <label for="price-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-select id="price-customFontWeight" v-model="curTable.customFontWeightPrice" size="sm">
                                            <option value="100">Thin - 100</option>
                                            <option value="200">Extra-LIght - 200</option>
                                            <option value="300">Light - 300</option>
                                            <option value="400">Regular - 400</option>
                                            <option value="500">Medium - 500</option>
                                            <option value="600">Semi-Bold - 600</option>
                                            <option value="700">Bold - 700</option>
                                            <option value="800">Extra-Bold - 800</option>
                                            <option value="900">Black - 900</option>
                                        </b-form-select>

                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                        <b-form-select id="button-customFontStyle" v-model="curTable.customFontStylePrice" size="sm">
                                            <option value="normal">Normal</option>
                                            <option value="italic">Italic</option>
                                        </b-form-select>
                                    </div>

                                </b-form-group>
                            </div>

                            <!-- font size plan -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="button-fontsizeTitle-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="curTable.fontSizePrice" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>


                            <!-- card title color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="colorPrice" theColorPicker="allpickers" colorPickerName="Price title color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <!-- currency price -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="plancurrency-text-input">Currency:</label>

                                    <b-form-input id="plancurrency-text-input" type="text" v-model="curTable.currency" size="sm" />

                                </b-form-group>
                            </div>
                            
                            <!-- font family currency -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !curTable.useCustomFontCurrency">
                                <b-form-group>
                                    <div style="display: flex">
                                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                                    </div>
                                    <b-form-select :options="googleFontsArray" @change="applyFont(arrayIndex,'fontGoogleLoadCurrency','fontFamilyCurrency','fontStyleCurrency','fontWeightCurrency')" v-model="curTable.fontGoogleLoadCurrency" size="sm" />
                                </b-form-group>
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.useCustomFontCurrency" name="use-custom-font">
                                    Use custom font
                                </b-form-checkbox>
                            </div>

                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && curTable.useCustomFontCurrency" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                                <b-form-group>

                                    <div class="setting">
                                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-input id="button-customFontName" type="text" v-model="curTable.customFontNameCurrency" size="sm" />
                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-select id="button-customFontWeight" v-model="curTable.customFontWeightCurrency" size="sm">
                                            <option value="100">Thin - 100</option>
                                            <option value="200">Extra-LIght - 200</option>
                                            <option value="300">Light - 300</option>
                                            <option value="400">Regular - 400</option>
                                            <option value="500">Medium - 500</option>
                                            <option value="600">Semi-Bold - 600</option>
                                            <option value="700">Bold - 700</option>
                                            <option value="800">Extra-Bold - 800</option>
                                            <option value="900">Black - 900</option>
                                        </b-form-select>

                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                        <b-form-select id="button-customFontStyle" v-model="curTable.customFontStyleCurrency" size="sm">
                                            <option value="normal">Normal</option>
                                            <option value="italic">Italic</option>
                                        </b-form-select>
                                    </div>

                                </b-form-group>
                            </div>

                            <!-- font size plan -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="button-fontsizeTitle-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="curTable.fontSizeCurrency" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>

                            <div class="setting">
                                <label for="align-currency">Align currency:</label>
                                <b-form-select id="align-currency" v-model="curTable.alignCurrency" size="sm">
                                    <option value="super">Super</option>
                                    <option value="sub">Sub</option>
                                    <option value="baseline">Baseline</option>
                                </b-form-select>
                            </div>


                            <!-- card title color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="colorCurrency" theColorPicker="allpickers" colorPickerName="Currency title color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>
                        </div>
                    </div>

                    <!-- ITEMS -->
                    <div class="setting-section">
                        <div class="setting-section-title">
                            <h6>Items</h6>
                        </div> 
                        <div class="setting-section-content">
                            <div class="setting">
                                <label>Add new item:</label>
                                <b-button size="sm" block variant="primary" @click="addPricingItem(arrayIndex)">Add Item</b-button>
                            </div>

                            <!-- font family item -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !curTable.useCustomFontItem">
                                <b-form-group>
                                    <div style="display: flex">
                                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                                    </div>
                                    <b-form-select :options="googleFontsArray" @change="applyFont(arrayIndex,'fontGoogleLoadItem','fontFamilyItem','fontStyleItem','fontWeightItem')" v-model="curTable.fontGoogleLoadItem" size="sm" />
                                </b-form-group>
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.useCustomFontItem" name="use-custom-font">
                                    Use custom font
                                </b-form-checkbox>
                            </div>

                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && curTable.useCustomFontItem" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                                <b-form-group>

                                    <div class="setting">
                                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-input id="button-customFontName" type="text" v-model="curTable.customFontNameItem" size="sm" />
                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-select id="button-customFontWeight" v-model="curTable.customFontWeightItem" size="sm">
                                            <option value="100">Thin - 100</option>
                                            <option value="200">Extra-LIght - 200</option>
                                            <option value="300">Light - 300</option>
                                            <option value="400">Regular - 400</option>
                                            <option value="500">Medium - 500</option>
                                            <option value="600">Semi-Bold - 600</option>
                                            <option value="700">Bold - 700</option>
                                            <option value="800">Extra-Bold - 800</option>
                                            <option value="900">Black - 900</option>
                                        </b-form-select>

                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                        <b-form-select id="button-customFontStyle" v-model="curTable.customFontStyleItem" size="sm">
                                            <option value="normal">Normal</option>
                                            <option value="italic">Italic</option>
                                        </b-form-select>
                                    </div>

                                </b-form-group>
                            </div>

                            <!-- font size item -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="button-fontsizeTitle-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="curTable.fontSizeItem" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>


                            <!-- card item color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="colorItem" theColorPicker="allpickers" colorPickerName="Item color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <!-- card item color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="bgItem" theColorPicker="allpickers" colorPickerName="Background item:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.hideIcon" name="use-icon-font">
                                    Use check icon
                                </b-form-checkbox>
                            </div>

                            <!-- card item icon color -->
                            <div class="setting" v-if="curTable.hideIcon">
                                <Mycolorpickerpricingtableschild elementRef="colorIcon" theColorPicker="allpickers" colorPickerName="Icon color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <!-- icon size item -->
                            <div class="setting" v-if="curTable.hideIcon">
                                <b-form-group>

                                    <label for="button-iconSize-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-iconSize-input" type="number" v-model="curTable.fontSizeIcon" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>

                        </div>
                    </div>

                    <!-- BUTTON -->
                    <div class="setting-section">
                        <div class="setting-section-title">
                            <h6>Button</h6>
                        </div> 
                        <div class="setting-section-content">
                            <!-- button text -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="planbtntext-text-input">Button text:</label>

                                    <b-form-input id="planbtntext-text-input" type="text" v-model="curTable.linkText" size="sm" />

                                </b-form-group>
                            </div>

                            <!-- button url -->
                            <div class="setting">
                                <b-form-group label="Button link:" label-for="button-url-input">

                                    <!-- extra settings toggle -->
                                    <span class="input-right-setting-icon button-target-settings-box-trigger" @click="targetSettingsBox = !targetSettingsBox" v-b-tooltip.hover.top title="Link Options">
                                        <i class="fas fa-cog"></i>
                                    </span>

                                    <b-form-input id="button-url-input" type="text"  class="input-with-right-setting-icon" v-model="curTable.link" size="sm" />

                                </b-form-group>
                                <div v-show="targetSettingsBox">

                                <!-- button target -->
                                <b-form-radio-group label="Open link in:" label-for="button-target-select" v-model="curTable.target" id="button-target-select">
                                        
                                        <b-form-radio value="_self" name="button-target">Open in same window</b-form-radio>

                                        <b-form-radio value="_blank" name="button-target">Open in new window</b-form-radio>

                                    </b-form-radio-group>

                                </div>
                            </div>

                            <!-- font family button -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !curTable.useCustomFontButton">
                                <b-form-group>
                                    <div style="display: flex">
                                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                                    </div>
                                    <b-form-select :options="googleFontsArray" @change="applyFont(arrayIndex,'fontGoogleLoadButton','fontFamilyButton','fontStyleButton','fontWeightButton')" v-model="curTable.fontGoogleLoadButton" size="sm" />
                                </b-form-group>
                            </div>

                            <!-- custom font family -->
                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                                <b-form-checkbox switch v-model="curTable.useCustomFontButton" name="use-custom-font">
                                    Use custom font
                                </b-form-checkbox>
                            </div>

                            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && curTable.useCustomFontButton" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                                <b-form-group>

                                    <div class="setting">
                                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-input id="button-customFontName" type="text" v-model="curTable.customFontNameButton" size="sm" />
                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                        <b-form-select id="button-customFontWeight" v-model="curTable.customFontWeightButton" size="sm">
                                            <option value="100">Thin - 100</option>
                                            <option value="200">Extra-LIght - 200</option>
                                            <option value="300">Light - 300</option>
                                            <option value="400">Regular - 400</option>
                                            <option value="500">Medium - 500</option>
                                            <option value="600">Semi-Bold - 600</option>
                                            <option value="700">Bold - 700</option>
                                            <option value="800">Extra-Bold - 800</option>
                                            <option value="900">Black - 900</option>
                                        </b-form-select>

                                    </div>

                                    <div class="setting">
                                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                        <b-form-select id="button-customFontStyle" v-model="curTable.customFontStyleButton" size="sm">
                                            <option value="normal">Normal</option>
                                            <option value="italic">Italic</option>
                                        </b-form-select>
                                    </div>

                                </b-form-group>
                            </div>

                            <!-- font size button -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="button-fontsizeTitle-input">Font size:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="curTable.fontSizeButton" min="5" step="1" />
                                    </b-input-group>

                                </b-form-group>
                            </div>


                            <!-- card title color -->
                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="colorButton" theColorPicker="allpickers" colorPickerName="Button text color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>

                            <div class="setting">
                                <Mycolorpickerpricingtableschild elementRef="bgButton" theColorPicker="allpickers" colorPickerName="Button background color:" :indexNr="arrayIndex" :curTable="curTable" />
                            </div>
                        </div>
                    </div>

                </div>
            </vue-draggable-resizable>

        </transition>


        <div v-if="showBlockActionButtons" :id="curTable.tableId+'-tooltip-delete'" class="delete-child-icon" @click="confirmBlockDelete = true">
            <i class="fas fa-times"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" :target="curTable.tableId+'-tooltip-delete'">
            <div class="delete-block-tooltip">Delete</div>
        </b-tooltip>

        <div class="confirm-block-deletion" v-if="confirmBlockDelete">
            <h4>Permanent Action</h4>
            <p>Are you sure you want to delete this pricing table?</p>
            <span @click="deleteChildBlock(arrayIndex)" class="confirm-delete-block-action">
                <i class="far fa-trash-alt"></i>Yes, delete.
            </span>
            <span @click="confirmBlockDelete = false">
                <i class="fas fa-ban"></i>Cancel.
            </span>
        </div>

        <div class="block-drag-handle" v-if="showBlockActionButtons">
            <i class="fas fa-ellipsis-h"></i>
        </div>
        <div v-if="showBlockActionButtons" class="settings-child-icon" @click="showChildBlockSettings(curTable.tableId)" :id="curTable.tableId+'-tooltip-settings'">
            <i class="fas fa-cog"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" class="access-settings-tooltip" :target="curTable.tableId+'-tooltip-settings'">
            <div class="access-settings-tooltip">Settings</div>
        </b-tooltip>

        <div v-if="showBlockActionButtons" class="copy-child-icon pricingcopy-icon" @click="copyChild(arrayIndex)" :id="curTable.tableId+'-tooltip-copy'">
            <i class="far fa-copy"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" class="access-copy-tooltip" :target="curTable.tableId+'-tooltip-copy'">
            <div class="access-copy-tooltip">Copy</div>
        </b-tooltip>

        <div class="bundle-pricing-table-header">
            <h4>{{curTable.planName}}</h4>
            <h5><span>{{curTable.currency}}</span> {{curTable.price}}</h5>
        </div>

        <draggable class="bundle-pricing-table-content" handle=".block-drag-handle-pt-item">
            
            <Pricingtableitem v-for="(item,index) in curTable.items" :key="index" :curItem="item" :arrayIndex="arrayIndex" :curTable="curTable" :curItemIndex="index" />

        </draggable>
  
        <div class="bundle-pricing-table-action">
            <a :href="curTable.link" :target="curTable.target" @click.prevent>
                <span>{{curTable.linkText}}</span>
            </a>
        </div>
    </div>


</template>

<script>
import Pricingtableitem from './Pricingtableitem'
import draggable from 'vuedraggable'
import Mycolorpicker from '../Mycolorpicker'
import Mycolorpickerpricingtableschild from '../Mycolorpickerpricingtableschild'

import VueDraggableResizable from 'vue-draggable-resizable'

export default {

    props: ['curTable','arrayIndex'],

    components: {
        Pricingtableitem,
        Mycolorpicker,
        Mycolorpickerpricingtableschild,

        draggable,

        'vue-draggable-resizable': VueDraggableResizable
    },

    name: 'PricingtableElement',

    data() {
        return {
            targetSettingsBox: false,
            editable_dashboard: true,

            // show child block action buttons: settings + delete
            showBlockActionButtons: false,
            showChildSettings: false,

            confirmBlockDelete: false,

            curSettings: '',

            setBoxWidth: 353,
            setBoxHeight: 403,

            centerPositionSettingsBoxX: null,
            centerPositionSettingsBoxY: null

        }
    },

    methods: {
        
        addPricingItem(arrayIndex) {
            console.log(arrayIndex,': ',this.$store.state.weeblySettings.settings.tables[arrayIndex].items);

            // this.removeActiveFromBlock()

            this.$store.state.weeblySettings.settings.tables[arrayIndex].items.push(
                {
                    name: 'new item included',
                }
            )
        },

        copyChild(elToCopy) {
            this.$store.state.weeblySettings.settings.tables.push(
                {
                    tableId: 'bundle-pricingtable-'+Math.random().toString(36).substr(2, 16),
                    planName: this.$store.state.weeblySettings.settings.tables[elToCopy].planName,
                    price: this.$store.state.weeblySettings.settings.tables[elToCopy].price,
                    currency: this.$store.state.weeblySettings.settings.tables[elToCopy].currency,
                    link: this.$store.state.weeblySettings.settings.tables[elToCopy].link,
                    linkText: this.$store.state.weeblySettings.settings.tables[elToCopy].linkText,
                    target: this.$store.state.weeblySettings.settings.tables[elToCopy].target,

                    useCustomFontPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].useCustomFontPlan,
                    customFontNamePlan: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontNamePlan,
                    customFontWeightPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontWeightPlan,
                    customFontStylePlan: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontStylePlan,

                    fontFamilyPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].fontFamilyPlan,
                    fontWeightPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].fontWeightPlan,
                    fontStylePlan: this.$store.state.weeblySettings.settings.tables[elToCopy].fontStylePlan,
                    fontGoogleLoadPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].fontGoogleLoadPlan,
                    fontSizePlan: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizePlan,
                    colorPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].colorPlan,
                    bgPlan: this.$store.state.weeblySettings.settings.tables[elToCopy].bgPlan,


                    useCustomFontPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].useCustomFontPrice,
                    customFontNamePrice: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontNamePrice,
                    customFontWeightPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontWeightPrice,
                    customFontStylePrice: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontStylePrice,

                    fontFamilyPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].fontFamilyPrice,
                    fontWeightPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].planNfontWeightPriceame,
                    fontStylePrice: this.$store.state.weeblySettings.settings.tables[elToCopy].fontStylePrice,
                    fontGoogleLoadPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].fontGoogleLoadPrice,
                    fontSizePrice: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizePrice,
                    colorPrice: this.$store.state.weeblySettings.settings.tables[elToCopy].colorPrice,

                    useCustomFontItem: this.$store.state.weeblySettings.settings.tables[elToCopy].useCustomFontItem,
                    customFontNameItem: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontNameItem,
                    customFontWeightItem: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontWeightItem,
                    customFontStyleItem: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontStyleItem,

                    fontFamilyItem: this.$store.state.weeblySettings.settings.tables[elToCopy].fontFamilyItem,
                    fontWeightItem: this.$store.state.weeblySettings.settings.tables[elToCopy].fontWeightItem,
                    fontStyleItem: this.$store.state.weeblySettings.settings.tables[elToCopy].fontStyleItem,
                    fontGoogleLoadItem: this.$store.state.weeblySettings.settings.tables[elToCopy].fontGoogleLoadItem,
                    fontSizeItem: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizeItem,
                    colorItem: this.$store.state.weeblySettings.settings.tables[elToCopy].colorItem,
                    bgItem: this.$store.state.weeblySettings.settings.tables[elToCopy].bgItem,

                    colorIcon: this.$store.state.weeblySettings.settings.tables[elToCopy].colorIcon,
                    fontSizeIcon: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizeIcon,
                    hideIcon: this.$store.state.weeblySettings.settings.tables[elToCopy].hideIcon,

                    useCustomFontCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].useCustomFontCurrency,
                    customFontNameCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontNameCurrency,
                    customFontWeightCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontWeightCurrency,
                    customFontStyleCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontStyleCurrency,

                    fontFamilyCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].fontFamilyCurrency,
                    fontWeightCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].fontWeightCurrency,
                    fontStyleCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].fontStyleCurrency,
                    fontGoogleLoadCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].fontGoogleLoadCurrency,
                    fontSizeCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizeCurrency,
                    colorCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].planNcolorCurrencyame,
                    alignCurrency: this.$store.state.weeblySettings.settings.tables[elToCopy].alignCurrency,

                    useCustomFontButton: this.$store.state.weeblySettings.settings.tables[elToCopy].useCustomFontButton,
                    customFontNameButton: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontNameButton,
                    customFontWeightButton: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontWeightButton,
                    customFontStyleButton: this.$store.state.weeblySettings.settings.tables[elToCopy].customFontStyleButton,

                    fontFamilyButton: this.$store.state.weeblySettings.settings.tables[elToCopy].fontFamilyButton,
                    fontWeightButton: this.$store.state.weeblySettings.settings.tables[elToCopy].fontWeightButton,
                    fontStyleButton: this.$store.state.weeblySettings.settings.tables[elToCopy].fontStyleButton,
                    fontGoogleLoadButton: this.$store.state.weeblySettings.settings.tables[elToCopy].fontGoogleLoadButton,
                    fontSizeButton: this.$store.state.weeblySettings.settings.tables[elToCopy].fontSizeButton,
                    colorButton: this.$store.state.weeblySettings.settings.tables[elToCopy].colorButton,
                    bgButton: this.$store.state.weeblySettings.settings.tables[elToCopy].bgButton,

                    items: [
                        {
                            name: 'item 1 included',
                        },
                        {
                            name: 'item 2 included',
                        },
                        {
                            name: 'item 3 included',
                        }
                    ]
                }
            )
        },

        updateTitle(arrayIndex) {
            // console.log(this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText)
            // this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText = event.target.innerText
        },

        showChildBlockSettings(titleId) {
            console.log(titleId)
        },

        deleteChildBlock(arrayIndex) {
            
            this.$store.state.weeblySettings.settings.tables.splice(this.arrayIndex, 1)
            this.confirmBlockDelete = false;

        },
        showChildBlockSettings(settingsToShow) {


            let curEvent = event.target
            setTimeout( () => {
                this.curSettings = document.getElementById('child-block-settings-'+settingsToShow)
                this.curIcon = curEvent
            },500)
            

            let guide = document.getElementById('child-block-settings-'+settingsToShow+'-guide')

            console.log('offset left guide ',guide.offsetLeft)
            console.log('offset top guide ',guide.offsetTop)

            this.centerPositionSettingsBoxX = guide.offsetLeft
            this.centerPositionSettingsBoxY = guide.offsetTop

            console.log(settingsToShow)

            // show child settings
            this.showChildSettings = true
            // add event listener
            setTimeout( ()=> {
                document.addEventListener('click', this.addClickSettingsBox)
            },1000)
            
        },
        addClickSettingsBox() {
            
            const el = this.curSettings
            const icon = this.curIcon
            let target = event.target

			if((el !== target && !el.contains(target)) && icon !== target) {

                setTimeout( () => {
                    document.removeEventListener('click', this.addClickSettingsBox)
                    // hide child settings
                    this.showChildSettings = false
                },150)
               
            } else {
                console.log(' target so leave settings')
            }

        },

        applyFont(arrayIndex,selector,fontfamily,fontstyle,fontweight) {

            console.log(event.target.value)

            let font = event.target.value

            // load google font
            this.$store.state.weeblySettings.settings.tables[arrayIndex][selector] = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontfamily] = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontfamily] = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontstyle] = 'italic'
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontweight] = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontweight] = fontStylePart
                this.$store.state.weeblySettings.settings.tables[arrayIndex][fontstyle] = 'normal'
            }

        },  

    },

    computed: {
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // get array of titles
        accordionTitlesArray() {
            return this.$store.state.weeblySettings.settings.accordionTitles
        },

        globalSettings() {
            return this.$store.state
        },
        // block guide
        showBlockChildSettingsGuide() {
            return this.$store.state.showBlockChildSettingsGuide
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        // google font picker
        googleFontsArray() {
            return this.$store.state.googleFontsToLoad
        }

    }

}
</script>

<style lang="less">
@import '../../../../less/colors.less';
.settings-box-child-guide {
    position: absolute;
    // top: calc(~"100% + 15px");
    top: 30px;
    left: 50%;
    margin-left: -175px;
    width: 350px;   
    height: 0px;
    opacity: 0;
    z-index: -2;
    overflow: hidden;
}
.bundle-accordion-element {
    position: relative;
}
.access-settings-tooltip, .delete-block-tooltip, .access-copy-tooltip {
    background: @action_blue;
    padding: 7px;
    font-weight: 700;
}

.access-copy-tooltip {
    background: @spark_green;
}

.delete-block-tooltip {
    background: @warning_red;
}
.confirm-block-deletion {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 350px;
    background: #fff;
    border: 1px solid @shark_light;
    z-index: 1000;
    font-size: 12px;
    border-radius: .25rem;
    text-align: center;
    box-shadow: 0 4px 10px fade(@shark_light, 25%);

    h4 {
        font-size: 20px;
        font-weight: 400;
        background: @shark_light;
        color: #fff;
        padding: 10px;
    }

    p {
        font-size: 13px;
        padding: 15px;
        margin: 0;
    }

    span {
        margin: 5px 5px 15px;
        display: inline-block;
        font-weight: 700;
        cursor: pointer;
        color: @text_grey;
        font-size: 13px;
        padding: 7px 12px;
        background: fade(@shark_light,12%);
        border-radius: .25rem;

        &:hover {
            opacity: .9;
        }

        i {
            margin-right: 7px;
        }
    }

    .confirm-delete-block-action {
        background: @warning_red;
        color: #fff;
    }
}

.copy-child-icon.pricingcopy-icon {
    position: absolute;
    top: -7px;
    left: 20px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @spark_green;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@spark_green, 85%);
    }
}

.block-drag-handle {
    position: absolute;
    top: -7px;
    left: 50%;
    height: 20px;
    width: 34px;
    margin-left: -17px;
    background: #fff;
    cursor: move;
    z-index: 10;
    border-radius: .25rem;
    text-align: center;
    border: 1px solid @action_blue;

    i {
        font-size: 10px;
        line-height: 20px;
        color: @action_blue;
    }
}

.settings-child-icon {
    position: absolute;
    top: -7px;
    left: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@action_blue, 85%);
    }
}

.delete-child-icon {
    z-index: 10;
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @warning_red;
    border-radius: .25rem;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    &:hover {
        background: fade(@warning_red, 85%);
    }
}

.sortable-chosen {
    opacity: .7;
    border: 1px solid @action_blue;
}
.ghost-block {
    background: @action_blue!important;
    opacity: .2;
}

input.div-like-input {
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 100%;
    outline: none!important;
    background: none;
    border: 0;
}



</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/pricingtableelement/PricingtableElement.vue